import React from "react";
import "../tracker/tracker.css";
import axios from "axios";
import jQuery from "jquery";
import Header from "../tracker/common/header";
import Footer from "../tracker/common/footer";
import GlobalFooter from "../tracker/common/globalFooter";
import Chart from "chart.js";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";

class CovidTracker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      apptitle: this.props.apptitle,
      covidData: [],
      covidCountries: []
    };
  }

  componentDidMount = (e) => {
    //e.preventDefault();

    axios
      .get("https://api.covid19api.com/summary", this.state)
      .then((res) => {
        // console.log(res.data);
        if (res.data) {
          //alert("Data Recieved Successfully!!");
          //var covidC = JSON.stringify(res.data.Countries);
          var Timestamp = res.data.Date;
          var date = new Date(Timestamp);
          //var dateTime = date.toDateString();
          var formattedDate =
            date.getDate() +
            "/" +
            (date.getMonth() + 1) +
            "/" +
            date.getFullYear();
          var formattedTime =
            date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
          jQuery("#Timestamp").html(formattedDate);
          jQuery("#datestamp").html(formattedTime);
          console.log(formattedDate);
          var covidC = res.data.Countries;
          // console.log(covidC);
          this.setState({ covidData: res.data });
          // console.log(this.state.covidData);
          this.setState({ covidCountries: covidC });
          //console.log(this.state.covidCountries);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    jQuery("#selectCountry").change(function () {
      //alert(jQuery("option:selected", this).attr("data-country"));
      jQuery("#CountryName").html(
        jQuery("option:selected", this).attr("data-country")
      );
      jQuery("#TotalConfirmed").html(
        jQuery("option:selected", this).attr("totalConfirmed")
      );
      jQuery("#NewConfirmed").html(
        jQuery("option:selected", this).attr("newConfirmed")
      );
      jQuery("#TotalRecovered").html(
        jQuery("option:selected", this).attr("totalRecovered")
      );
      jQuery("#NewRecovered").html(
        jQuery("option:selected", this).attr("newRecovered")
      );
      jQuery("#TotalDeaths").html(
        jQuery("option:selected", this).attr("totalDeaths")
      );
      jQuery("#NewDeaths").html(
        jQuery("option:selected", this).attr("newDeaths")
      );
      jQuery("#TotalActive").html(
        jQuery("option:selected", this).attr("newConfirmed")
      );
      jQuery("#NewActive").html(
        jQuery("option:selected", this).attr("newConfirmed")
      );

      if (jQuery("option:selected", this).val() === "IN") {
        jQuery("#stateTextColumn").removeClass("hideColumn");
      } else {
        jQuery("#stateTextColumn").addClass("hideColumn");
      }
      if (jQuery("option:selected", this).val() === "US") {
        jQuery("#USstateTextColumn").removeClass("hideColumn");
      } else {
        jQuery("#USstateTextColumn").addClass("hideColumn");
      }
    });
  };

  refreshdata = (e) => {
    e.preventDefault();
    location.reload();
  };

  render() {
    return (
      <section className="tracker-section">
        <Header title={this.props.apptitle} />

        <div className="container bodyContainer">
          <div className="row">
            <div className="col-12">
              <div className="updated-time-column text-center">
                <p>
                  <i className="fa fa-bell"></i>&nbsp; Last Updated &nbsp;
                  <span id="Timestamp"></span> &nbsp;
                  <span id="datestamp"></span> HRS
                </p>
              </div>
            </div>

            <div className="col-12">
              <div className="details-column row">
                <div className="col-12">
                  <label> Choose Country</label>
                  <select className="form-control" id="selectCountry">
                    <option key="null" value="null">
                      - Select Country
                    </option>
                    {this.state.covidCountries.map((covidCountry) => (
                      <option
                        key={covidCountry.CountryCode}
                        value={covidCountry.CountryCode}
                        data-country={covidCountry.Country}
                        newConfirmed={covidCountry.NewConfirmed}
                        totalConfirmed={covidCountry.TotalConfirmed}
                        newRecovered={covidCountry.NewRecovered}
                        totalRecovered={covidCountry.TotalRecovered}
                        newDeaths={covidCountry.NewDeaths}
                        totalDeaths={covidCountry.TotalDeaths}
                      >
                        - {covidCountry.Country}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div
                className="details-column row hideColumn"
                id="stateTextColumn"
              >
                <div className="col-12 stateTextColumn ">
                  <Link to="/indiadata">Click to View State Wise Data</Link>
                </div>
              </div>
              <div
                className="details-column row hideColumn"
                id="USstateTextColumn"
              >
                <div className="col-12 stateTextColumn">
                  <Link to="/usadata">Click to View State Wise Data</Link>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-12">
                  <p>
                    <strong>Country Name: </strong>
                  </p>
                  <h2>
                    <strong>
                      <span id="CountryName">****</span>
                    </strong>
                  </h2>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-6">
                  <div className="col-inner red-col">
                    <p>Confirmed:</p>
                    <h2>
                      <strong>
                        <span className="smallText" id="">
                          <span className="sign">+</span>&nbsp;
                          <span id="NewConfirmed">**</span>
                        </span>
                        <span id="TotalConfirmed">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
                <div className="col-6">
                  <div className="col-inner blue-col">
                    <p>Active</p>
                    <h2>
                      <strong>
                        <span className="smallText" id="">
                          <span className="sign">+</span>&nbsp;
                          <span id="NewActive">**</span>
                        </span>
                        <span id="TotalActive">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-6">
                  <div className="col-inner green-col">
                    <p>Recovered</p>
                    <h2>
                      <strong>
                        <span className="smallText">
                          <span className="sign">+</span>&nbsp;
                          <span id="NewRecovered">**</span>
                        </span>
                        <span id="TotalRecovered">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
                <div className="col-6">
                  <div className="col-inner red-col">
                    <p>Deceased</p>
                    <h2>
                      <strong>
                        <span className="smallText" id="">
                          <span className="sign">+</span>&nbsp;
                          <span id="NewDeaths">**</span>
                        </span>
                        <span id="TotalDeaths">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="row">
                <GlobalFooter />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CovidTracker;
